import React, { useState, useEffect, useMemo } from "react";
import DocumentTitle from "react-document-title";

import SectionTable, { SectionHead } from "styles/components/SectionTable";
import { restApiBaseUrl } from "constants/api";
import IconSvgComponent from "components/common/IconSvgComponent";
import { addNotification, openModal } from "store/state/ui/actions";
import { LEVELS, createNotification } from "utilities/notification";
import { useDispatch } from "react-redux";
import { NoDataComponent, PaginatedTable } from "components/common/table";
import { getAccessToken } from "utilities/localStore";
import ButtonLink from "components/common/ButtonLink";
import { StyledSpan } from "styles/components/TableDefault";
import { Tab, TabMenu } from "components/TabMenu";
import { MODAL_CREATE_ASSESSMENT } from "lib/constants";

const apiUrl = restApiBaseUrl;

const columns = [
  {
    id: "name",
    Header: "Name",
    accessor: "name",
    minWidth: 200,
    maxWidth: 300,
    Cell: (props) => {
      return (
        <ButtonLink
          isRouterLink
          noLeftPadding
          to={`/admin/assessments/${props.row.original.id}`}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <IconSvgComponent iconPath="svg/assessment.svg" />
          <StyledSpan
            hasIconOnLeft
            bold
            style={{
              whiteSpace: "nowrap",
              overflowX: "clip",
              textOverflow: "ellipsis",
            }}
          >
            {props.value}
          </StyledSpan>
        </ButtonLink>
      );
    },
  },
  {
    id: "type",
    Header: "Type",
    accessor: "type",
    minWidth: 200,
    maxWidth: 250,
  },
  {
    id: "form",
    Header: "Form",
    accessor: "form",
    minWidth: 150,
    maxWidth: 200,
  },
  {
    id: "version",
    Header: "Version",
    accessor: "version",
    minWidth: 100,
  },
  {
    id: "question_count",
    Header: "Questions",
    accessor: "question_count",
    minWidth: 100,
  },
  {
    id: "series",
    Header: "Series",
    accessor: "assessment_series_id",
    minWidth: 100,
  },
];

const AdminPage = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [assessments, setAssessments] = useState([]);
  const [activeTab, setActiveTab] = useState("__all");

  useEffect(() => {
    const fetchAssessments = async () => {
      setIsLoading(true);
      try {
        const url = `${apiUrl}/rest/assessments`;

        const result = await fetch(url, {
          mode: "cors",
          method: "get",
          headers: {
            Authorization: getAccessToken(),
            "Content-Type": "application/json",
          },
        }).then((response) => response.json());

        setAssessments(result.data);
      } catch (error) {
        console.log({ error });
      }
      setIsLoading(false);
    };
    fetchAssessments();
  }, []);

  const filteredAssessments = useMemo(() => {
    if (activeTab === "__all") {
      return assessments;
    } else {
      return assessments.filter((a) => a.type === activeTab);
    }
  }, [assessments, activeTab]);

  return (
    <DocumentTitle title="Stemify | Administration">
      <SectionTable style={{ padding: "10px" }}>
        <ButtonLink
          className="button-add"
          onClick={() => dispatch(openModal({ type: MODAL_CREATE_ASSESSMENT }))}
          violet
          fab
          size="43"
        />

        <SectionHead style={{ marginBottom: "10px" }}>
          <h2 style={{ textAlign: "center" }}>Assessment Manager</h2>
          <TabMenu>
            <Tab value="__all" activeTab={activeTab} setActiveTab={setActiveTab}>
              All
            </Tab>
            <Tab value="Placement Assessment" activeTab={activeTab} setActiveTab={setActiveTab}>
              Placement
            </Tab>
            <Tab value="Exam" activeTab={activeTab} setActiveTab={setActiveTab}>
              Exam
            </Tab>
            <Tab value="Practice Assessment" activeTab={activeTab} setActiveTab={setActiveTab}>
              Practice
            </Tab>
          </TabMenu>

          <PaginatedTable
            data={filteredAssessments}
            columns={columns}
            isLoading={isLoading}
            NoDataComponent={() => (
              <div style={{ height: "487px", padding: "65px 24px" }}>
                <NoDataComponent type="Assessment" iconPath="svg/ico-rocket-dark-lg.svg" />
              </div>
            )}
            showPagination={assessments.length >= 10}
            style={{ fontSize: "14px", fontWeight: 500 }}
            // {...tableState.additionalProps}
          />
        </SectionHead>
      </SectionTable>
    </DocumentTitle>
  );
};

export default AdminPage;
